import { Avatar, Box, Button, ButtonGroup, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { RootState } from "../../app/features/store/store";
import RcImage from "../../images/route.png";
import LoadTruckImage from "../../images/truck_load.png";
import RtsNoticeDialog from "../returnToStation/RtsNoticeDialog";
import { useState } from "react";

const breadcrumb = ["Home"];

const Home = () => {
  const navigate = useNavigate();
  const userDetails = useSelector(
    (state: RootState) => state.login?.authResponse?.userSettings
  );

  // change Administrators to Driver in prod.
  const IsFdpAdmin = useSelector((state: RootState) =>
    state.login?.authResponse?.userSettings
      ? state.login?.authResponse?.userSettings?.roles.includes("FDP_ADMIN")
      : false
  );

  const isDriver = useSelector((state: RootState) =>
    state.login?.authResponse?.userSettings
      ? state.login?.authResponse?.userSettings?.roles.length === 1 &&
        state.login?.authResponse?.userSettings?.roles.includes("FDP_DRIVER")
      : false
  );

  const isFdp = useSelector(
    (state: RootState) => state.login?.authResponse?.isFdp
  );

  const isFdcAdmin = useSelector((state: RootState) =>
    state.login?.authResponse?.userSettings
      ? state.login?.authResponse?.userSettings?.roles.includes(
          "Administrators"
        )
      : false
  );

  const [isRtsNoticeDialogOpen, setIsRtsNoticeDialogOpen] = useState(false);

  return (
    <>
      {userDetails?.roles.includes("Administrators") && (
        <Navigate to="/dedicated-delivery" replace />
      )}
      {userDetails?.roles.includes("FDP_ADMIN") && (
        <Navigate to="/user" replace />
      )}
      {(userDetails?.roles.includes("FDC_OPS_Fin_admin") ||
        userDetails?.roles.includes("FDC_Fin_admin")) && (
        <Navigate to="/clients" replace />
      )}
      {!userDetails?.roles.includes("Administrators") && isDriver && (
        <Box sx={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              sx={{
                bgcolor: green[800],
                margin: 5,
                width: 60,
                height: 60,
                fontSize: "20px",
              }}
            ></Avatar>
            <Typography variant="body2">{userDetails?.userName}</Typography>
          </div>
          <div>
            <ButtonGroup fullWidth variant="contained">
              <Button
                sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
              >
                <Typography variant="h6"> Total Deliveries :</Typography>
              </Button>
            </ButtonGroup>
            <ButtonGroup fullWidth variant="outlined" orientation="vertical">
              <Button
                size="large"
                style={{ justifyContent: "flex-start" }}
                onClick={() => setIsRtsNoticeDialogOpen(true)}
              >
                {" "}
                &nbsp; &nbsp; &nbsp;
                <img src={RcImage} width={40}></img>
                <Typography variant="h4">
                  &nbsp; <strong>RTS</strong> &nbsp;
                </Typography>
                <Typography variant="subtitle2">(Add RTS)</Typography>
              </Button>

              <RtsNoticeDialog
                isOpen={isRtsNoticeDialogOpen}
                onClose={() => setIsRtsNoticeDialogOpen(false)}
              />

              {/*<Button
                size="large"
                style={{ justifyContent: "flex-start" }}
                onClick={() => navigate("/addRTS")}
              >
                <img src={RtsImage} width={80}></img>
                <Typography variant="h4">
                  <strong>RTS</strong> &nbsp;
                </Typography>
                <Typography variant="subtitle2">(Return to Station)</Typography>
            </Button>*/}

              <Button
                disabled
                size="large"
                style={{
                  justifyContent: "flex-start",
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10,
                }}
              >
                {" "}
                &nbsp; &nbsp; &nbsp;
                <img src={LoadTruckImage} width={50}></img>
                <Typography variant="h4">
                  &nbsp; &nbsp; <strong>LIV</strong> &nbsp;
                </Typography>
                <Typography variant="subtitle2">(Load in Vehicle)</Typography>
              </Button>
            </ButtonGroup>
          </div>
          <div></div>
        </Box>
      )}
    </>
  );
};

export default Home;
